import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/enterprise/page.tsx");
